import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { applySeo } from "@/lib/seo";
import { adminBase } from "@/lib/panelMeta";

export default function SeoHead() {
  const { settings } = useSite();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!settings) return;
    const base = adminBase();
    const isAdmin = pathname === base || pathname.startsWith(`${base}/`);
    applySeo(settings, { pathname, noindex: isAdmin });
  }, [settings, pathname]);

  return null;
}
